import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Card READ-ONLY da conta de margem de futuros (USDT-M) + posições abertas.
 * Reaproveitado pelas telas cientes de mercado (Carteira/Dashboard em modo Futuros).
 * Para ABRIR/FECHAR posições, a "mesa" é a aba /futures (que tem o card com os botões).
 *
 * props:
 *  - account: { balance: { balance, available } | null, positions: [{ symbol, side, amount,
 *              entryPrice, markPrice, unRealizedProfit, liquidationPrice, leverage }] }
 *  - showTradeHint: bool — mostra o aviso "use a aba Futuros pra operar" (default true)
 */
function fmt(n, d = 2) {
    return (n == null || isNaN(parseFloat(n)) ? '—' : parseFloat(n).toFixed(d));
}

function FuturesAccountCard({ account, showTradeHint = true }) {
    const positions = (account && account.positions) || [];
    const balance = account && account.balance;
    return (
        <div className='card card-body border-0 shadow mb-4'>
            <h5 className='h6'>Conta de Margem (USDT-M)</h5>
            {balance
                ? <p className='mb-3'>Saldo: <strong>{fmt(balance.balance)} USDT</strong> · Disponível: <strong>{fmt(balance.available)} USDT</strong></p>
                : <p className='text-muted'>Sem saldo de margem (ou credenciais de futuros não configuradas — veja a aba <Link to='/futures'>Futuros</Link>).</p>}
            <h6 className='h6'>Posições abertas</h6>
            {positions.length === 0
                ? <p className='text-muted mb-0'>Nenhuma posição aberta.</p>
                : (
                    <div className='table-responsive'>
                        <table className='table table-sm align-middle mb-0'>
                            <thead>
                                <tr>
                                    <th>Símbolo</th><th>Lado</th><th className='text-end'>Qtde</th><th className='text-end'>Entrada</th>
                                    <th className='text-end'>Marca</th><th className='text-end'>PnL ñ-real.</th><th className='text-end'>Liquidação</th><th className='text-end'>Alav.</th>
                                </tr>
                            </thead>
                            <tbody>
                                {positions.map(p => (
                                    <tr key={p.symbol}>
                                        <td><strong>{p.symbol}</strong></td>
                                        <td><span className={`badge ${p.side === 'LONG' ? 'bg-success' : 'bg-danger'}`}>{p.side}</span></td>
                                        <td className='text-end'>{p.amount}</td>
                                        <td className='text-end'>{fmt(p.entryPrice)}</td>
                                        <td className='text-end'>{fmt(p.markPrice)}</td>
                                        <td className={`text-end ${p.unRealizedProfit >= 0 ? 'text-success' : 'text-danger'}`}>{fmt(p.unRealizedProfit)}</td>
                                        <td className='text-end'>{fmt(p.liquidationPrice)}</td>
                                        <td className='text-end'>{p.leverage}x</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            {showTradeHint && <small className='text-muted mt-2 d-block'>Para abrir/fechar posições, use a aba <Link to='/futures'>Futuros</Link>.</small>}
        </div>
    );
}

export default FuturesAccountCard;
